define('modules/profiler',['require','exports','module','modules/tester/Stats','modules/tester/InternetSpeed','modules/media/pusher','modules/gallery','modules/yotta','app'],function(require, exports, module) {"use strict";

	// For IE8 and earlier version.
	if (!Date.now) {
		Date.now = function() {
			return new Date().valueOf();
		};
	}

	var Stats = require("modules/tester/Stats");
	var InternetSpeed = require("modules/tester/InternetSpeed");

	var mediaPusher = require("modules/media/pusher");

	var Gallery = require("modules/gallery");
	var Yotta = require("modules/yotta");

	var timing = 1500;

	var FPS = 0;
	var speed = 0;

	var _isSupportedBrowser = false, _isHtml5 = false, _isDesktop = false, _isHighPerformance = false, _isHighBandwidth = false;

	var app = require("app");
	module.exports ={

		getParameterByName : function(name){
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
			return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
		},

		get_device : function(){
			var r = 0;

			if (app.current_device === 'desktop'){
				r = 1;
			}

			var force = this.getParameterByName('view');
		if (force !== ""){
				r = force;
			}

			return r;
		},

		Tester : function(hashroute) {
			var self = this;

			_isSupportedBrowser = this.isSupportedBrowser();
			_isHtml5 = this.isHtml5();
			_isDesktop = this.isDesktop();
			this.PerformanceTest();
			
			
			
			setTimeout(function() {
				_isHighPerformance = self.isHighPerformance();
				
				//console.log(_isHighPerformance ,self.getScore() );
				
				self.BandwidthTest(function(speed) {
					
					_isHighBandwidth = self.isHighBandwidth(speed);
					
					var Score = self.getScore();
					self.setTesterScore(Score);
					
					var ViewType = self.getViewTypeByScore(hashroute, Score);
					self.setViewType( ViewType );
					
					
					
					self.disableLoader();
					
					
										
					return ViewType;
				});

			}, timing);
		},
		
		disableLoader: function() {
			var loader = document.getElementById( "isloader");
			loader.className = "loaderHidden";
		},

		isSupportedBrowser : function() {
			var browser = $.browser;
			var version = $.browser.version;

			if ((browser == "msie" && version < 8 ) || (browser == "mozilla" && version < 3.6 ) || (browser == "webkit" && version < 3 ) || (browser == "safari" && version < 4 ) || (browser == "opera" && version < 10 )) {
				return false;
			}
			return true;
		},

		isHtml5 : function() {
			var is = !!document.createElement('canvas').getContext;
			this.setHtml5(is);

			return is;
		},

		setHtml5 : function(is) {
			if (_.isUndefined(app.html5)) {
				app.html5="";
			}
			app.html5 = is;
		},

		setMediatype : function(a) {
			if (_.isUndefined(app.mediatype)) {
				app.mediatype="";
			}
			app.mediatype = a;
		},

		setTesterScore : function(a) {
			if (_.isUndefined(app.testerscore)) {
				app.testerscore="";
			}
			app.testerscore = a;
		},

		setViewType : function(a) {
			if (_.isUndefined(app.ViewType)) {
				app.ViewType = {};
			}
			app.ViewType = a;
		},

		isDesktop : function(browserType) {
			return (this.get_device() == 1);
		},

		PerformanceTest : function() {
			Stats.Begin();

			var Pf = setInterval(function() {
			
				Stats.Update();
			}, 1000 / 60);
			
			 

			var self = this;
			setTimeout(function() {

				clearInterval(Pf);
				Stats.End();
				self.setFPS(Stats.getFps());

			}, timing);
		},

		setFPS : function(num) {
			FPS = num;
		},

		getFPS : function() {
			return FPS;
		},

		isHighPerformance : function() {
			return (this.getFPS() > 17 );
		},

		BandwidthTest : function(callback) {
			var self = this;
			
			

			var Copertina = _.values( modules_cfg )[0] ;
			var CopertinaRes = mediaPusher.get_media_res();
			var CopertinaOri = mediaPusher.get_orientation();

			var ImageTester = Copertina.contents.imgs[CopertinaOri][CopertinaRes];
			
			
			

			InternetSpeed.Check(ImageTester, function(speed) {
				
			
				callback(speed);
			});
		},

		isHighBandwidth : function(kbps) {

			this.setMediatype("default");

			var testHigh = (kbps > 1);
			var testMedium = (kbps > 0.85);

			var mediares = mediaPusher.get_media_res();

			if (!testHigh && mediares !== "small") {
				if (!testMedium) {
					this.setMediatype("small");
				} else {
					if (mediares == "large") {
						this.setMediatype("medium");
					} else if (mediares == "medium") {
						this.setMediatype("small");
					}
				}
			}

			return testHigh;
		},

		getViewTypeByScore : function(subroute, score) {
			switch( score ) {
				case 1:
				case 2:
					return new Yotta({
						hash : subroute
					});
					//break;

				case 3:
				case 4:
				case 5:
					return new Gallery({
						hash : subroute
					});
					//break;

				default:
					// TODO Gestione della Scriptless, implementato per prova la gallery.
					return new Gallery({
						hash : subroute
					});
					//break;
			}
		},

		getScore : function() {

			/*
			 * 0 -> Scriptless
			 * 1 -> AdvanceAdHoc
			 * 2 -> AdvanceModium
			 * 3 -> GalleryAdHoc
			 * 4 -> GalleryMedium
			 * 5 -> GalleryLow
			 */

			if (!_isSupportedBrowser || !_isHtml5 || !(_isDesktop && _isHighPerformance )) {
				return 0;
			} else {
				if (_isDesktop && _isHighPerformance) {
					if (_isHighBandwidth) {
						return 1;
					} else {
						return 2;
					}
				} else if (_isDesktop && !_isHighPerformance) {
					if (_isHighBandwidth) {
						return 4;
					} else {
						return 5;
					}
				} else if (!_isDesktop) {
					if (_isHighBandwidth) {
						return 3;
					} else {
						return 5;
					}
				}
			}

		}
	};

});

